import { TranslationsFunc } from '@lang';
import { z } from 'zod';

export const buildTableFormSchema = (t: TranslationsFunc) =>
  z
    .object({
      restaurant: z
        .object({
          value: z.string(),
          restaurantName: z.string().optional(),
        })
        .nullable()
        .refine((val) => val !== null, { message: 'Required' }),
      guests: z.object({
        adults: z
          .string()
          .refine((val) => val && Number.isInteger(Number(val)) && Number(val) > 0, {
            message: 'Required',
          }),
        children: z.string().optional(),
      }),
      startDate: z.any(),
      visitDate: z
        .any()
        .refine((val) => val !== null && val !== undefined, { message: 'Required' }),
      timeslot: z
        .string()
        .nullable()
        .refine((val) => val !== null && val !== '' && val !== undefined, { message: 'Required' }),
      promotion: z
        .object({
          id: z.union([z.string(), z.number()]).optional().nullable(),
          timeslotReservationId: z.string().optional().nullable(),
        })
        .nullable()
        .optional(),
      promotionId: z.union([z.string(), z.number()]).nullable().optional(),
      timeslotReservationId: z.string().nullable().optional(),
      note: z.string().optional(),
      hasDietaryRequirements: z.boolean().optional(),
      dietaryRequirements: z.array(z.string()).optional(),
      hasCelebrationOptions: z.boolean().optional(),
      celebrationOptions: z.array(z.string()).optional(),
    })
    .superRefine((data, ctx) => {
      if (data.hasDietaryRequirements) {
        if (!data.dietaryRequirements || data.dietaryRequirements.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('tables.dietaryRequirementError'),
            path: ['dietaryRequirements'],
          });
        }
      }

      if (data.hasCelebrationOptions) {
        if (!data.celebrationOptions || data.celebrationOptions.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('tables.celebrationOptionsError'),
            path: ['celebrationOptions'],
          });
        }
      }
    });

const tableFormSchemaForType = buildTableFormSchema(
  ((key: string) => key) as unknown as TranslationsFunc
);

export type TableFormValues = z.infer<typeof tableFormSchemaForType>;
